'use client';

import { ComponentPropsWithRef, ComponentRef, forwardRef } from 'react';
import { Link as NavLink } from '@/i18n/routing';
import { ExternalLink } from './external-link';
import { InternalLink } from './internal-link';

type Props = ComponentPropsWithRef<typeof NavLink>;

export const Link = forwardRef<ComponentRef<'a'>, Props>(
  ({ href, prefetch = true, children, className, locale, ...rest }, ref) => {
    const hrefString = typeof href === 'string' ? href : href.href;
    if (!hrefString) {
      return null;
    }
    const isExternal = /^https?:\/\//i.test(hrefString);

    if (isExternal) {
      return (
        <ExternalLink className={className} href={href} ref={ref}>
          {children}
        </ExternalLink>
      );
    }
    return (
      <InternalLink
        className={className}
        href={href}
        locale={locale}
        ref={ref}
        prefetch={prefetch}
        {...rest}
      >
        {children}
      </InternalLink>
    );
  },
);

Link.displayName = 'Link';
